import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/OopsPage.css';

interface OopsPageProps {
  error?: string;
  resetError?: () => void;
}

const OopsPage: React.FC<OopsPageProps> = ({ error, resetError }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    if (resetError) resetError();
    navigate('/');
  };

  return (
    <div className="oops-container">
      <div className="oops-content">
        <div className="oops-icon">⚠️</div>
        <h1 className="oops-title">Oops!</h1>
        <p className="oops-message">Something went wrong on our end.</p>
        
        {error && (
          <details className="oops-details">
            <summary>Error details</summary>
            <pre className="oops-error-text">{error}</pre>
          </details>
        )}

        <p className="oops-help-text">
          Don't worry, our team has been notified. Please try refreshing the page or go back home.
        </p>

        <div className="oops-actions">
          <button 
            onClick={() => window.location.reload()} 
            className="oops-button oops-button--primary"
          >
            Refresh Page
          </button>
          <button 
            onClick={handleGoHome}
            className="oops-button oops-button--secondary"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default OopsPage;
